export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Délai de commande expiré",
      "649f8aefc1c0": "Échec du recyclage",
      "649f8aefc9c0": "Obtenir un nouveau devis",
      "TradeIn": "Processus Trade-In",
      "logistic": "Télécharger l'étiquette d'expédition",
      "start": "Commencer le processus",
      "success": "Vous avez bien reçu votre nouvel appareil",
      "qc": "Contrôle qualité de l'ancien appareil",
      "business": "L'inspection de votre ancien appareil sera terminée sous 3 jours ouvrés",
      "completed": "Terminé",
      "successfully": "Félicitations ! Votre Trade-In a été finalisé avec succès",
      "orderInfor": "Informations de commande",
      "orderID": "ID de commande Trade-In",
      "orderNum": "ID de commande du nouvel appareil",
      "createTime": "Date de création",
      "brand": "Marque estimée",
      "model": "Modèle estimé",
      "price": "Valeur de l'ancien appareil",
      "bonus": "Bonus",
      "reclaimFailure": "Comme vous n'avez pas expédié l'appareil dans les 10 jours suivant sa réception, la commande Trade-In a expiré et été annulée. Si vous souhaitez toujours effectuer le Trade-In, cliquez sur le bouton ci-dessous pour consulter le dernier devis.",
      "total": "Prix total",
      "logisticInfo": "Informations logistiques",
      "available": "Aucune information logistique disponible",
      "logisticNum": "Numéro logistique",
      "failRey": "Nous sommes désolés que votre participation au programme Trade-In de OnePlus n'ait pas pu aboutir. Si vous souhaitez recycler d'autres produits électroniques, cliquez sur le bouton ci-dessous pour obtenir une estimation rapide !",
      "userRes": "L'utilisateur a déjà refusé l'offre.",
      "successPrice": "Le prix ci-dessous a été défini après inspection professionnelle. Si vous acceptez ce prix, vous pouvez poursuivre le Trade-In. Si vous le refusez, l'appareil vous sera renvoyé sous quelques jours ouvrés.",
      "sure": "Accepter",
      "Reject": "Refuser",
      "congratulation": "Félicitations ! Aucun écart détecté lors du contrôle qualité.",
      "finPirce": "Prix final",
      "copySuccess": "Copie réussie",
      "copyfail": "Échec de la copie",
      "sureSuccess": "Confirmer la transaction réussie",
      "submitError": "Échec de l'envoi",
      "detectionResult": "Résultat du diagnostic",
      "Collected": "Passer commande",
      "inTransit": "En transit",
      "656g0lj3sav6": "Processus de recyclage",
      "656g0lj3cd5a": "Renseignez correctement vos informations personnelles et validez la commande",
      "656g0lj3dr9a": "L'inspection de votre téléphone sera effectuée dans les 48 heures suivant sa réception dans notre centre",
      "656g0lj3epal": "Une fois l'inspection terminée, nous vous contacterons par e-mail avec l'offre finale",
      "656g0lj3pda2": "Votre estimation",
      "656g0lj3ed3d": "Contrôle qualité professionnel",
      "656g0lj3esf3": "Copier",
      "expertDiscount": "Code promotionnel",
      "invalidCode": "Code invalide",
      "toastTip": "Cochez pour accepter la Politique de confidentialité et les Conditions générales",
      "649f8aef26sf": "Processus Trade-In",
      "checkTitle": "Informations de test",
      "basicInformation": "Informations de base",
      "understand": "Je comprends"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Refuser le recyclage",
      "64a9shqq3k00": "Vous confirmez refuser le recyclage",
      "64a9shqq3r00": "Annulation réussie",
      "64a9shqq3ws0": "Échec de l'annulation",
      "sureCancel": "Confirmer l'annulation"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Qui",
      "646u995lv9g0": "sommes-nous?",
      "646u9d5lv9g0": "Danghuan est une entreprise dont l'activité principale est axée sur le recyclage, le traitement et la vente de produits numériques 3C tels que les smartphones, tablettes, ordinateurs portables et montres connectées. Notre société vise à accroître l'efficacité du recyclage électronique et à promouvoir un développement durable du marché de l'occasion. Nous avons établi des partenariats stratégiques officiels avec OPPO, Vivo, OnePlus, Realme et d'autres. Nos activités internationales se sont étendues en Inde, Thaïlande, Vietnam, Cambodge et désormais en Europe.",
      "646u995dv9g0": "Notre présence mondiale nous positionne comme partenaire stratégique des opérateurs mobiles, fabricants et grossistes à l'échelle régionale et internationale.",
      "646u99slv9g0": "Nous collaborons avec des fabricants de référence et maintenons un large stock d'appareils d'entrée, milieu et haut de gamme. Cela nous permet de proposer des solutions sur mesure et des prix compétitifs adaptés aux besoins de nos clients."
    },
    "business": {
      "646v04syvpk0": "Souhaitez-vous acheter nos produits ?",
      "646v04syxs80": "Chez Danghuan, nous proposons une large sélection de smartphones, tablettes et montres connectées, disponibles dans différents grades pour répondre aux exigences de chaque entreprise.",
      "646v04syy6g0": "Contactez notre Responsable des ventes et achats :",
      "646v04syya80": "Je souhaite acheter",
      "646v04syydg0": "Entrez votre nom",
      "646v04syyh40": "Entrez votre numéro de téléphone",
      "646v04syyyw0": "Entrez votre adresse e-mail",
      "646v0gsyz1s0": "Pays :",
      "646v04syz1s0": "Veuillez choisir une option",
      "646v04syz4o0": "J'ai lu et j'accepte",
      "646v04syzkc0": "la Politique de confidentialité",
      "646v04syzok0": "Contactez-nous",
      "646v04syzvo0": "Veuillez entrer votre numéro de téléphone",
      "646v04syzys0": "Veuillez entrer votre adresse e-mail",
      "646v04sz01o0": "Veuillez saisir une adresse e-mail valide",
      "646v04sz04g0": "Veuillez entrer votre nom",
      "646v04sz0740": "Cochez la case pour accepter la politique de confidentialité",
      "646v04sz0a00": "Soumission réussie",
      "646v04sz0cw0": "Échec de la soumission",
      "title1": "Classification transparente des appareils",
      "text1-1": "Pour vous aider dans vos décisions d'achat, nous vous invitons à consulter notre document de classification détaillé. Il présente les critères esthétiques et fonctionnels de chaque grade afin de vous permettre de faire un choix éclairé.",
      "title2": "Support client exceptionnel",
      "text2-1": "Nous comprenons les besoins uniques de chaque client, c'est pourquoi notre équipe de vente multilingue fournit une assistance personnalisée et professionnelle.",
      "title3": "Engagement pour une technologie durable",
      "text3-1": "Nous nous engageons à promouvoir l'accès mondial à des solutions technologiques durables et à garantir que nos processus créent de la valeur pour toutes les parties prenantes.",
      "text3-2": "Pour toute question ou pour organiser une commande d'essai, veuillez nous contacter. Notre équipe se fera un plaisir de vous aider avec professionnalisme et attention."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Recevez votre paiement en seulement 4 étapes",
      "s1": "Première étape",
      "s1t": "Emballez votre appareil afin qu'il arrive dans le même état que lors de l'envoi.",
      "s2": "Deuxième étape",
      "s2t": "Déposez votre colis dans notre point relais.",
      "s3": "Troisième étape",
      "s3t": "Nous vérifions votre appareil et vous envoyons un devis.",
      "s4": "Quatrième étape",
      "s4t": "Recevez votre paiement rapidement."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Restez informé",
      "section3-text2": "Tablettes",
      "section3-text4": "Montres",
      "section3-text5": "Autres",
      "title": "Évaluation rapide",
      "t1": "Sélectionnez le type d'appareil et lancez l'évaluation pour obtenir une offre équitable.",
      "t2": "Quelques étapes simples pour profiter de notre service de recyclage rapide !"
    },
    "section6": {
      "646txzpazuc0": "À propos de Danghuan",
      "666txzpazuc0": "Entreprise spécialisée dans le recyclage et la réutilisation des smartphones, tablettes et autres appareils numériques, offrant un processus simple, sûr et efficace pour permettre à chaque client de recycler facilement son appareil usagé.",
      "646txzpb0rk0": "Détails",
      "646txzpb0xc0": "Recyclage disponible pour 12 marques"
    },
    "section7": {
      "646ns2k5f7k0": "Notre service est disponible à tout moment",
      "646ns2k5gmw0": "Service client : du lundi au vendredi, de 9h00 à 18h00 CET (UTC+1:00) Madrid, Espagne",
      "646ns2k5gs40": "Entrez votre nom",
      "646ns2k5gx40": "Entrez votre numéro de téléphone",
      "646ns2k5img0": "Entrez votre adresse e-mail",
      "646ns2k5isw0": "Écrivez-nous un message avant que nous ne vous contactions",
      "646ns2k5iws0": "Contactez-nous",
      "646ns2k5j140": "Veuillez entrer votre numéro de téléphone",
      "646ns2k5j4g0": "Veuillez entrer votre adresse e-mail",
      "646ds2k5j4g0": "E-mail",
      "646ns2k5j6c0": "Veuillez entrer une adresse e-mail valide",
      "646ns2k5j8g0": "Contactez-nous",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Adresse",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Espagne",
      "646ns2k5jgc0": "Veuillez entrer votre nom",
      "646ns2k5ji40": "Cochez la case pour accepter la politique de confidentialité",
      "646ns2k5jk00": "Soumission réussie",
      "646ns2k5jm80": "Échec de la soumission",
      "646ny1rgz3c0": "J'ai lu et j'accepte ",
      "646ny1rh2k40": "la Politique de confidentialité"
    },
    "successMain": {
      "647qmd42l1s0": "Commande reçue avec succès !",
      "647qmd42mss0": "Veuillez prêter attention à l'e-mail contenant les instructions d'expédition envoyé depuis no-reply@danghuan.eu. Si vous ne l'avez pas reçu, vérifiez votre dossier SPAM ou contactez notre service client à insta360@danghuan.eu.",
      "647qmd42mz80": "Notre offre",
      "647qmd42yeo0": "Conseils avant l'expédition",
      "orderTime": "Date de commande",
      "text1": "Expédition gratuite",
      "text2": "Veuillez prêter attention au document d'expédition envoyé à votre adresse e-mail.",
      "text3": "Sauvegarde des données",
      "text4": "Pour protéger vos informations, sauvegardez vos données et supprimez tout le contenu ou réinitialisez l'appareil.",
      "text5": "Recharge",
      "text6": "Veuillez charger votre téléphone à au moins 1 % avant l'envoi afin d'accélérer l'inspection.",
      "downloadDec": "Veuillez télécharger la Déclaration d'intégrité."
    },
    "tradeInProcess": {
      "649f8aefats0": "Délai de commande expiré",
      "649f8aefc1c0": "Échec du recyclage",
      "649f8aefc9c0": "Obtenir un nouveau devis",
      "TradeIn": "Processus Trade-In",
      "logistic": "Télécharger l'étiquette d'expédition",
      "start": "Commencer le processus",
      "success": "Vous avez bien reçu votre nouvel appareil",
      "qc": "Contrôle qualité de l'ancien appareil",
      "business": "L'inspection de votre ancien appareil sera terminée sous 3 jours ouvrés",
      "completed": "Terminé",
      "successfully": "Félicitations ! Votre Trade-In a été finalisé avec succès",
      "orderInfor": "Informations de commande",
      "orderID": "Numéro de commande de recyclage",
      "orderNum": "ID de commande du nouvel appareil",
      "createTime": "Date de création",
      "brand": "Marque estimée",
      "model": "modèle",
      "price": "Valeur de l'ancien appareil",
      "bonus": "Bonus",
      "total": "Prix total",
      "logisticInfo": "Informations logistiques",
      "available": "Aucune information logistique disponible",
      "logisticNum": "Numéro logistique",
      "failRey": "Nous sommes désolés que votre participation au programme Trade-In de OnePlus n'ait pas pu aboutir. Si vous souhaitez recycler d'autres produits électroniques, cliquez sur le bouton ci-dessous pour obtenir une estimation rapide !",
      "userRes": "L'utilisateur a déjà refusé l'offre.",
      "successPrice": "Le prix ci-dessous a été défini après inspection professionnelle. Si vous acceptez ce prix, vous pouvez poursuivre le Trade-In. Si vous le refusez, l'appareil vous sera renvoyé sous quelques jours ouvrés.",
      "sure": "Accepter",
      "Reject": "Refuser",
      "congratulation": "Félicitations ! Aucun écart détecté lors du contrôle qualité.",
      "finPirce": "Prix final",
      "copySuccess": "Copie réussie",
      "copyfail": "Échec de la copie",
      "sureSuccess": "Confirmer la transaction réussie",
      "submitError": "Échec de l'envoi",
      "detectionResult": "Résultat du diagnostic",
      "Collected": "Collecté",
      "inTransit": "En transit / Expédition",
      "understand": "Je comprends",
      '656g0lj3sf6e': "Les bonus promotionnels sont offerts et gérés par les marques partenaires.Ils seront versés séparément et ne font pas partie de l'évaluation de l'ancien appareil."
    },
    "btnDialog": {
      "64a9shqq2ks0": "Refuser le recyclage",
      "64a9shqq3k00": "Vous confirmez refuser le recyclage",
      "64a9shqq3r00": "Annulation réussie",
      "64a9shqq3ws0": "Échec de l'annulation",
      "sureCancel": "Confirmer l'annulation"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Informations personnelles",
      "649fhwp9zbo0": "Téléchargez une photo claire de votre colis",
      "649fhwpa1900": "Télécharger l'étiquette d'expédition",
      "649fhwpa1l00": "Télécharger l'étiquette d'expédition",
      "649fhwpa1tc0": "Livraison terminée",
      "649fhwpa2100": "Photo du colis et Déclaration d'honnêteté",
      "649fhwpa2880": "Exemple de placement de l'étiquette d'expédition",
      "649fhwpa2h80": "Remarque",
      "649fhwpa2qk0": "Emballage : enveloppez le téléphone dans du papier bulle et remplissez la boîte de papier ou de protection pour éviter tout dommage pendant le transport.",
      "649fhwpa2xs0": "Remplissez les espaces vides avec un matériau de protection pour éviter les chocs.",
      "649fhwpa3fk0": "Étiquette logistique : apportez l'étiquette (numérique ou imprimée) au point relais ; l'étiquette officielle sera imprimée sur place.",
      "649fhwpa3v40": "Veuillez envoyer votre ancien téléphone dès que possible. Si l'envoi n'est pas effectué dans les 10 jours, la commande sera annulée.",
      "649fhwpa42s0": "Recherche de points de dépôt",
      "649fhwpa4as0": "Télécharger l'étiquette",
      "649fhwpa4jo0": "Télécharger",
      "649fhwpa4ok0": "Accueil",
      "649fhwpa4to0": "Soumission réussie",
      "649fhwpa4yk0": "Félicitations, le téléchargement a réussi !",
      "649fhwpasf3s": "Attention",
      "649fhwpaa6f3": "Veuillez imprimer et signer la Déclaration d'honnêteté, puis prendre une photo de celle-ci avec le colis de votre ancien appareil et la télécharger."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Réseaux sociaux",
      "646d71qugz40": "Paiement facile",
      "646u51qugz40": "Logistique",
      "646u5dqui780": "Politique de confidentialité",
      "646uddqui780": "Conditions générales",
      "646u51qui780": "FAQ"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "À propos de Danghuan",
      "646ntjwmn580": "Entreprise",
      "646nt7hwils0": "Contactez-nous",
      "646nt7hwipg0": "Acheter",
      "646nt7hwis00": "Vendre"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Estimation gratuite"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Entrez le modèle que vous souhaitez vendre",
      "646wgb1nj8o0": "Terme de recherche",
      "646wgb1nji80": "J'ai déclenché la recherche par glissement",
      "empty": "Désolé, ce modèle n'existe pas",
      "confirm": "Confirmer",
      "cancle": "Annuler",
      "dialogText": "Êtes-vous sûr de vouloir supprimer tout l'historique\ndes enregistrements ?"
    }
  },
  "PCProduct": {
    "empty": "Désolé, ce modèle n'existe pas"
  },
  "PCBrandTab": {
    "index": "Marque"
  },
  "PCCategoryTab": {
    "index": "Catégorie"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Commander en ligne",
      "646xagqwkuw0": "Expédition gratuite",
      "646xagqwmao0": "Test",
      "646xagqwmlc0": "Paiement rapide"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Accueil"
    }
  },
  "router": {
    "selectModel": "Modèles",
    "selectProperty": "Problèmes de l'appareil",
    "price": "Prix estimé",
    "priceOrder": "Passer commande",
    "orderSuccess": "Commande réussie"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Re-sélectionner le modèle",
      "646ymq6ot0k0": "Rappel",
      "646ymq6pd100": "Avant l'envoi, veuillez vous déconnecter du compte cloud",
      "646ymq6pekw0": "du verrouillage d'écran / de l'Apple ID sur l'ancien appareil."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Sélectionner l'état de l'appareil",
      "647h1f4yr6c0": "Prix estimé",
      "647h1f4yso80": "Bonus estimé",
      "text1": "Expédition gratuite",
      "text2": "Nous offrons un service logistique et d'expédition gratuit",
      "text3": "Paiement immédiat",
      "text4": "Nous effectuerons le paiement dans un délai de 3 jours ouvrés après réception de votre appareil.",
      "64tve23zt0g0": "Expédition gratuite et kit de vente",
      "64tve23zup00": "Effacement sécurisé des données",
      "64tve23zuy40": "Pas satisfait ? Retour gratuit",
      "64tve23zv7g0": "Le paiement sera effectué dans un délai de 3 jours ouvrés après réception de l'appareil.",
      "64tve23zvbg0": "Choisissez votre méthode d'expédition",
      "64tve23zvf80": "Vous disposez de 10 jours pour envoyer votre téléphone.",
      "64tve23zvjc0": "Obtenez une étiquette d'expédition gratuite et envoyez votre appareil.",
      "64tve23zvms0": "L'étiquette d'expédition sera envoyée à votre adresse e-mail.",
      "64tve23zvqg0": "Remarque :",
      "64tve23zvyo0": "En raison des restrictions d'expédition liées aux batteries au lithium, n'envoyez pas l'appareil si vous soupçonnez que la batterie est défectueuse ou endommagée.",
      "64tve23zwak0": "Nous ne pourrons pas retourner les accessoires ou emballages envoyés avec l'appareil.",
      "64tve23zwgs0": "Étapes suivantes pour vendre votre téléphone",
      "64tve23zwm80": "Renseignez vos coordonnées",
      "64tve23zwt00": "Préparez votre téléphone pour l'envoi",
      "64tve23zwwk0": "Votre appareil sera inspecté dès son arrivée. Si les informations fournies sont inexactes, une nouvelle offre vous sera envoyée. Vous pourrez l'accepter ou demander le retour gratuit de votre appareil."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "Canal d'achat",
      "646ynp3ueas0": "Nécessite une activation, ne peut pas passer d'appels normalement",
      "646ynp3uehw0": "Entrez le numéro IMEI",
      "646ynp3uem40": "Composez *#06# sur le clavier pour vérifier l'IMEI du téléphone."
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Voir l'offre"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Rappel : le prix des téléphones et produits électroniques peut diminuer jusqu'à 6 %, nous vous recommandons donc d'expédier votre colis dès que possible.",
      "647hqss760c0": "J'ai lu et j'accepte la",
      "647hqss764w0": "Politique de confidentialité",
      "647hqss76ac0": "Conditions générales",
      "647hqss76dg0": "Soumettre",
      "647hqss76gw0": "Prix total (Évaluation de l'appareil usagé)",
      "text1": "Total",
      "text2": "Prix estimé",
      "text3": "Bonus estimé",
      "dialogTitle": "Avis",
      "dialogText": "Cliquez sur le bouton CONFIRMER et vérifiez votre e-mail pour poursuivre l'étape suivante",
      "dialogBtn": "CONFIRMER"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Informations de commande",
      "647kboa06ys0": "Nom",
      "647kboa0d6v8": "Indicatif du pays",
      "647kboa078s0": "Téléphone",
      "647kboa07d00": "Adresse",
      "647kboa07jk0": "Pays",
      "647kboa07p80": "Veuillez sélectionner",
      "647kboa08b40": "Code postal",
      "647kboa08h00": "Ville",
      "647kboa08zc0": "Adresse",
      "647kboa09440": "Informations bancaires",
      "647kboa096w0": "Vérification de l'e-mail",
      "647kboa09ao0": "E-mail",
      "647kboa09dk0": "Code de vérification",
      "647kboa09u40": "Entrer",
      "647kboa09z80": "Envoyer",
      "647kboa0ak00": "Erreur de format d'e-mail",
      "647kboa0aog0": "Envoi réussi",
      "send": "Envoyé",
      "submit": "Soumettre",
      "error": "Erreur de code de vérification",
      "64jjt96fg400": "Veuillez entrer le code de vérification",
      "64jjt96fki00": "Veuillez obtenir le code de vérification",
      "idNumber": "Numéro de carte d'identité / ID",
      "declaration": "Déclaration d'intégrité",
      "download": "Télécharger",
      "647kboa0idc0": "Pièce d'identité (ID)",
      "647kboa0idc1": "(le numéro d'identité officiel délivré par votre pays, utilisé pour l'identification dans les procédures juridiques, fiscales ou administratives. cela peut être votre DNI, NIE, numéro d'identification fiscale, numéro d'identification personnel, CNP, ou un autre document national équivalent, selon votre pays de résidence.)",
      "647kboa0idc2": "(le numéro d'identité officiel délivré par votre pays, utilisé pour l'identification dans les procédures juridiques, fiscales ou administratives. cela peut être votre DNI, NIE, numéro d'identification fiscale, numéro d'identification personnel, CNP, ou un autre document national équivalent, selon votre pays de résidence.)",
      "idError": "Numéro d'identification invalide",
      "ibanTip": "Utilisé pour recevoir le paiement de l'ancien appareil.",
      "addreddPlaceholder": "Ce champ prend en charge jusqu’à 105 caractères"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Page d'accueil",
      "notRecyclable": "Ce type d'appareil ne peut pas être recyclé",
      "IKnow": "Je comprends",
      "tips": "Conseils"
    }
  },

  "blog": {
    "blogList": {
        "64wgr171lsk0": "Vues",
        "64wgr171nq40": "Aucun contenu disponible",
        "64wgr171av65": "Date"
    },
    "blogDetail": {
        "64wgr9y5r7s0": "Vues",
        "64wgr171wdx9": "Détails"
    }
  },

  "cookieNotice": {
    "title": "Avis sur les cookies",
    "description": "Nous utilisons des cookies pour améliorer votre expérience de navigation. En continuant à utiliser ce site, vous acceptez notre",
    "cookiePolicy": "Politique relative aux cookies",
    "acceptAll": "Accepter tous les cookies",
    "acceptNecessary": "Accepter uniquement les cookies nécessaires",
    "customize": {
      "title": "Veuillez sélectionner les types de cookies que vous souhaitez accepter :",
      "necessary": {
        "label": "Cookies nécessaires",
        "description": "Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés."
      },
      "analytics": {
        "label": "Cookies d'analyse",
        "description": "Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site."
      },
      "marketing": {
        "label": "Cookies marketing",
        "description": "Ces cookies suivent l'activité des utilisateurs sur plusieurs sites pour proposer des publicités pertinentes."
      }
    },
    "save": "Enregistrer les paramètres",
    "cancel": "Annuler"
  }
}